import "../App.css";
import fill from "../assets/fill.mp4";

import { createRef, useEffect, useState } from "react";
import {
  Pause,
  PlayArrow,
  Replay10,
  VolumeOff,
  VolumeUp,
  Fullscreen,
  FullscreenExit,
} from "@material-ui/icons";
import data from "../data.json";
import {
  Box,
  Button,
  ButtonGroup,
  ClickAwayListener,
  CssBaseline,
  Grid,
} from "@material-ui/core";
import SideMenu from "../SideMenu/SideMenu";
import TopBar from "../TopBar/TopBar";
import { db } from "../firebase-config";
import { FullScreen, useFullScreenHandle } from "react-full-screen";

function VideoComponent(props) {
  const videoRef = createRef();
  const [previousSection, setPreviousSection] = useState();
  const [playing, setPlaying] = useState(false);
  const [videoData, setVideoData] = useState({});
  const [popup, setPopup] = useState();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [played, setPlayed] = useState([]);
  const [playedActions, setPlayedActions] = useState([]);
  const [time, setTime] = useState();
  const handleFS = useFullScreenHandle();

  const handleDrawerOpen = () => {
    if (popup) return;
    setDrawerOpen(!drawerOpen);
  };
  const drawerOnClose = () => {
    setDrawerOpen(false);
  };

  useEffect(() => {
    setVideoData(props.data);
  }, [props]);

  const init = () => {
    let duration = 0;
    let lastInteractionTime = 0;
    if (videoRef && videoRef.current) {
      duration = videoRef.current.duration;
    }
    let sections = data.interactions.map((interaction) => {
      let time = interaction.time || duration;
      interaction.duration = time - lastInteractionTime;
      lastInteractionTime = interaction.time;
      interaction.disabled = true;
      return interaction;
    });
    setVideoData({ ...videoData, duration, sections });
  };

  const toggleSound = (muted = false) => {
    const x = videoRef.current;
    x.muted = !x.muted;
    setVideoData({ ...videoData, muted: x.muted });
  };

  const toggleVideo = async () => {
    try {
      if (popup) return;
      const x = videoRef.current;
      if (x.paused) {
        x.play();
      } else {
        x.pause();
      }
      if (props.member) {
        const emailDoc = await db
          .collection("savehearts_video")
          .doc(props.member)
          .get();
        let emailData = emailDoc.data();
        if (!emailData.actions) emailData.actions = [];
        emailData.actions = [
          ...emailData.actions,
          {
            action: x.paused ? "Pause" : "Play",
            time: Date.now(),
          },
        ];
        db.collection("savehearts_video").doc(props.member).set(emailData);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const seekVideo = async (forward = true) => {
    try {
      if (videoRef && videoRef.current) {
        let time = videoRef.current.currentTime;
        let currentSection = videoData.interactions.find(
          (interaction) => interaction.active === true
        );
        if (forward) {
          time += 10;
        } else {
          time -= 10;
        }
        if (time < currentSection.start) {
          time = currentSection.start;
        }
        if (currentSection.time && time >= currentSection.time) {
          time = currentSection.time - 1;
        }
        videoRef.current.currentTime = time;
      }

      if (props.member) {
        const emailDoc = await db
          .collection("savehearts_video")
          .doc(props.member)
          .get();
        let emailData = emailDoc.data();
        if (!emailData.actions) emailData.actions = [];
        emailData.actions = [
          ...emailData.actions,
          {
            action: forward ? "Forward" : "Backward",
            time: Date.now(),
            videoTime: Math.round(time),
          },
        ];
        db.collection("savehearts_video").doc(props.member).set(emailData);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const goToPreviousOptions = () => {
    if ((videoRef && videoRef.current) || previousSection) {
      const videoElm = videoRef.current;
      videoElm.currentTime = previousSection.time;
    }
  };

  const replaySection = (section) => {
    // console.log(section);
    console.log(played);
    console.log(played[section.nextSection]);
    setPreviousSection([]);
    if (videoRef && videoRef.current) {
      const videoElm = videoRef.current;
      videoElm.play();
      videoElm.currentTime = section.time;
      let selectedSection = videoData.interactions.find(
        (interaction) => interaction.title === section.title
      );
      if (selectedSection && selectedSection.sections) {
        const index = selectedSection.actions
          .map((action) => action.html)
          .indexOf(section.title);
        if (index !== -1 && !played.includes(index + 1)) {
          setPlayed([...played, index + 1]);
        }
        // console.log(played);
      }
    }

    setPlayed([]) // to reset the stored played actions to prevent the video from behaving as it has seen this section before
    setPlayedActions([]) // same idea

  };

  const timeChange = () => {
    const x = videoRef.current;
    setTime(x.currentTime);
    if (videoData) {
      if (data.interactions) {
        const interactions = data.interactions.map((interaction) => {
          interaction.active =
            parseInt(x.currentTime) >= parseInt(interaction.start) &&
            (parseInt(x.currentTime) <= parseInt(interaction.time) || !interaction.time);
          if (interaction.active) {
            interaction.disabled = false;
          }
          if (Math.round(x.currentTime) === Math.round(interaction.time)) {
            if (interaction.actions.length > 0) {
              if (interaction.title === "calling") {
                x.pause();
              } else if (interaction.sections) {
                setPopup(interaction);
                let currentPlayed = played[interaction.nextSection];
                if (currentPlayed === undefined) currentPlayed = [];
                if (interaction.automatic) {
                  setPreviousSection(null)
                  if (playedActions.indexOf(interaction.actions[0].time) === -1) {
                    playSection(interaction.nextSection, 1, interaction.actions[0])
                  }
                  else {
                    continueVideo({ time: interaction.nextSection })
                    setPlayedActions([])
                  }
                  console.log(currentPlayed);
                  setPopup();
                }
                else {
                  if (currentPlayed.length >= interaction.actions.length) {
                    continueVideo({ time: interaction.nextSection }); // im setting time in an object because in this function it will access the time like this "t.time"
                    setPopup();
                  } else {
                    x.pause();
                  }
                }
              } else {
                setPopup(interaction);
                x.pause();
              }
            }
          }
          return interaction;
        });
        setVideoData({ ...videoData, interactions });
      }
    }
  };
  const playSection = (section_id, id, action) => {
    // console.log("playSection", section_id, action);
    let currentPlayed = played[section_id];

    if (currentPlayed === undefined) currentPlayed = [];
    let currentSection = videoData.interactions.find(
      (interaction) => interaction.active === true
    );
    if (currentSection?.showInLibrary) {
      setPreviousSection(currentSection);
      // console.log('section  : ', currentSection);
    }

    let tmpActions = [...playedActions, action.time]
    setPlayedActions(tmpActions)
    // console.log('updated played actions : ', playedActions);
    // console.log('played actions', playedActions);
    let tmp = {
      ...played,
      [section_id]: [...currentPlayed, id],
    };
    setPlayed(tmp);
    try {
      console.log(currentSection);

      const action = currentSection.actions[parseInt(id) - 1];
      continueVideo(action);
    } catch (error) {
      console.log(error);
      // console.log(currentSection);
    }
  };
  const continueVideo = async (t) => {
    let currentSection = videoData.interactions.find(
      (interaction) => interaction.active === true
    );
    // console.log(currentSection);

    if (currentSection?.showInLibrary) {
      setPreviousSection(currentSection);
      // console.log('section  : ', currentSection);
    }
    const x = videoRef.current;
    if (t.time > 0) {
      x.currentTime = (t.time);
      if (Math.round(x.currentTime) === Math.round(parseInt(t.time))) {
        x.currentTime += 1;
      }
      x.play();
      setPopup();
    }
    if (props.member) {
      const emailDoc = await db
        .collection("savehearts_video")
        .doc(props.member)
        .get();
      let emailData = emailDoc.data();
      if (!emailData.actions) emailData.actions = [];
      emailData.actions = [
        ...emailData.actions,
        {
          action: "Select",
          section: t,
          time: Date.now(),
        },
      ];
      db.collection("savehearts_video").doc(props.member).set(emailData);
    }
  };
  return (
    <div style={{ justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
      <h1 className="title" style={{ position: 'relative', width: '100%', alignSelf: 'center', marginBottom: '-25px', marginTop: '-10px', textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: videoData.title }}></h1>
      <>
        <FullScreen handle={handleFS}>
          {handleFS.active && (
            <>
              {/* <img className="logo" src={logo} alt="logo" /> */}
              <div
                className="fullscreen-bg"
                style={{
                  backgroundImage: `url(${videoData.background_image})`,
                }}
              />
            </>
          )}

          {videoData && (
            <div handle={handleFS} className="backgroundVideo">

              <CssBaseline />
              <ClickAwayListener onClickAway={drawerOnClose}>
                <div>
                  <TopBar open={drawerOpen} handleDrawerOpen={handleDrawerOpen} />
                  <SideMenu
                    sections={videoData.sections}
                    goToSection={replaySection}
                    open={drawerOpen}
                    onClose={drawerOnClose}
                  />
                </div>
              </ClickAwayListener>

              {videoData.url && (
                <video
                  ref={videoRef}
                  id="video1"
                  onLoadedData={init}
                  poster={videoData.poster}
                  onTimeUpdate={timeChange}
                  onPlaying={() => setPlaying(true)}
                  onPause={() => setPlaying(false)}
                  onVolumeChange={() =>
                    setVideoData({ ...videoData, muted: videoRef.current.muted })
                  }
                  playsInline
                >
                  <source id="mp4" src={fill} type="video/mp4" />
                  <p>Your user agent does not support the HTML5 Video element.</p>
                </video>

              )}
              {/* {videoData.code && <div className="video-code">{videoData.code}</div>} */}
              <div className="content toggleOnHover">
                <Box p={2}>
                  <Grid container justifyContent="space-between">
                    <Grid item>
                      <ButtonGroup
                        color="primary"
                        aria-label="outlined primary button group"
                      >
                        {
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => seekVideo(false)}
                          >
                            <Replay10 />
                          </Button>
                        }
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={toggleVideo}
                        >
                          {(playing && <Pause />) || <PlayArrow />}
                        </Button>
                        {/* {previousSection && (
                          <Button
                            className="back"
                            variant="contained"
                            color="primary"
                            onClick={goToPreviousOptions}
                          >
                            <div
                            >
                              Back to choices
                            </div>
                          </Button>
                        )} */}
                      </ButtonGroup>
                    </Grid>
                    <Grid item>
                      <ButtonGroup
                        color="primary"
                        aria-label="outlined primary button group"
                      >
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() =>
                            handleFS.active ? handleFS.exit() : handleFS.enter()
                          }
                        >
                          {(handleFS.active && <FullscreenExit />) || (
                            <Fullscreen />
                          )}
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={toggleSound}
                        >
                          {(videoData.muted && <VolumeOff />) || <VolumeUp />}
                        </Button>
                      </ButtonGroup>
                    </Grid>
                  </Grid>
                </Box>
              </div>
              {/* {time} */}
            </div>
          )}
          {popup && (
            <div className="lightbox">
              {popup.question && (
                <div
                  style={popup.style ? popup.style : { width: "60%", padding: 10 }}
                  className="button longbtnsQuestion "
                  dangerouslySetInnerHTML={{ __html: popup.question }}
                ></div>
              )}
              <div className="longbtnsContainer">
                {popup.actions.map((action, i) => {
                  return (
                    <div
                      style={action.style ? action.style : {}}
                      className={`button longbtns`}
                      onClick={() => {
                        if (popup.sections) {
                          playSection(popup.nextSection, i + 1, action);
                        }
                        else {
                          continueVideo(action)
                        }
                      }}
                      key={i}
                      dangerouslySetInnerHTML={{ __html: action.html }}
                    ></div>
                  )
                })}
              </div>
            </div>
          )
          }
        </FullScreen>
      </>
    </div>
  );
}

export default VideoComponent;
